export const modeFromSettings = settings =>
  !settings.enabled ? 'off' : settings.dryRun ? 'test' : 'live';
export const settingsForMode = mode =>
  mode === 'off'
    ? { enabled: false, dryRun: true }
    : { enabled: true, dryRun: mode !== 'live' };
export const MODE_OPTIONS = [
  { id: 'off', label: 'Off', help: 'Rate Shop does nothing.' },
  {
    id: 'test',
    label: 'Test mode',
    help: 'Checks every order and logs what it would choose; changes nothing in ShipStation.'
  },
  {
    id: 'live',
    label: 'Live',
    help: 'Writes the cheapest carrier/service/package to ShipStation orders.'
  }
];
